import { render, staticRenderFns } from "./TeaserItemImage.vue?vue&type=template&id=cf8b51b0"
import script from "./TeaserItemImage.vue?vue&type=script&lang=ts"
export * from "./TeaserItemImage.vue?vue&type=script&lang=ts"
import style0 from "./TeaserItemImage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default})
